/**
 * @generated SignedSource<<2814f311a728eec5f5c6ef709c26d5b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GaveFeedbackModalNewFeedbackMutation$variables = {};
export type GaveFeedbackModalNewFeedbackMutation$data = {
  readonly createDraftFeedback: {
    readonly feedback: {
      readonly id: string;
    };
  } | null;
};
export type GaveFeedbackModalNewFeedbackMutation = {
  response: GaveFeedbackModalNewFeedbackMutation$data;
  variables: GaveFeedbackModalNewFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "REQUESTED"
      }
    ],
    "concreteType": "CreateDraftFeedback",
    "kind": "LinkedField",
    "name": "createDraftFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FeedbackNode",
        "kind": "LinkedField",
        "name": "feedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "createDraftFeedback(type:\"REQUESTED\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GaveFeedbackModalNewFeedbackMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GaveFeedbackModalNewFeedbackMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b11c9291e33fd389ab79253ab1d89ca5",
    "id": null,
    "metadata": {},
    "name": "GaveFeedbackModalNewFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation GaveFeedbackModalNewFeedbackMutation {\n  createDraftFeedback(type: REQUESTED) {\n    feedback {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a82dae683c504ba924146a3953b20f16";

export default node;
